import React from 'react';
import {Container, Typography, Link} from '@mui/material';
import {styled} from '@mui/material/styles';

const StyledFooter = styled('footer')(({theme})=>({
    flexGrow: 0,
    flexShrink: 0,
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    textAlign: 'center',
    backgroundColor:
        theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
}));

function Copyright() {
    return (
      <Typography variant='body2' color='textSecondary'>
        {'Copyright © '}
        <Link color='inherit' target='_blank' href='https://pragmaspace.com' rel='noreferrer'>
          Ubidex
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
}

export default function Footer() {
    return (
      <StyledFooter>
        <Container maxWidth='sm'>
          <Copyright />
        </Container>
      </StyledFooter>
    );
}
